<template>
    <div class="wysiwyg-wrapper">
        <div class="wysiwyg-toolbar" :class="{readonly: computedOptions.readonly}">
            <a class="button toolbar-button" @click.prevent="toolbarClicked('makeHeadline2')" :class="{'is-active': testPresenceinSelection('makeHeadline2', 'makeHeadline2')}">
                <span class="text">H2</span>
            </a>
            <a class="button toolbar-button" @click.prevent="toolbarClicked('makeHeadline3')" :class="{'is-active': testPresenceinSelection('makeHeadline3', 'makeHeadline3')}">
                <span class="text">H3</span>
            </a>

            <a class="button toolbar-button" @click.prevent="toolbarClicked('bold')" :class="{'is-active': testPresenceinSelection('bold', 'bold')}">
                <span class="icon">
                    <svg viewBox="0 0 18 18">
                        <path class="stroke" d="M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z"></path>
                        <path class="stroke" d="M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z"></path>
                    </svg>
                </span>
            </a>

            <a class="button toolbar-button" @click.prevent="toolbarClicked('italic')" :class="{'is-active': testPresenceinSelection('italic', 'italic')}">
                <span class="icon">
                    <svg viewBox="0 0 18 18">
                        <line class="stroke" x1="7" x2="13" y1="4" y2="4"></line>
                        <line class="stroke" x1="5" x2="11" y1="14" y2="14"></line>
                        <line class="stroke" x1="8" x2="10" y1="14" y2="4"></line>
                    </svg>
                </span>
            </a>

            <a class="button toolbar-button" @click.prevent="toolbarClicked('underline')" :class="{'is-active': testPresenceinSelection('underline', 'underline')}">
                <span class="icon">
                    <svg viewBox="0 0 18 18">
                        <path class="stroke" d="M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3"></path>
                        <rect class="fill" height="1" rx="0.5" ry="0.5" width="12" x="3" y="15"></rect>
                    </svg>
                </span>
            </a>

            <a class="button toolbar-button" @click.prevent="toolbarClicked('makeOrderedList')" :class="{'is-active': testPresenceinSelection('makeOrderedList', 'makeOrderedList')}">
                <span class="icon">
                    <svg viewBox="0 0 18 18">
                        <line class="stroke" x1="7" x2="15" y1="4" y2="4"></line>
                        <line class="stroke" x1="7" x2="15" y1="9" y2="9"></line>
                        <line class="stroke" x1="7" x2="15" y1="14" y2="14"></line>
                        <line class="stroke thin" x1="2.5" x2="4.5" y1="5.5" y2="5.5"></line>
                        <path class="fill" d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z"></path>
                        <path class="stroke thin" d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"></path>
                        <path class="stroke thin" d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109"></path>
                    </svg>
                </span>
            </a>

            <a class="button toolbar-button" @click.prevent="toolbarClicked('makeUnorderedList')" :class="{'is-active': testPresenceinSelection('makeUnorderedList', 'makeUnorderedList')}">
                <span class="icon">
                    <svg viewBox="0 0 18 18">
                        <line class="stroke" x1="6" x2="15" y1="4" y2="4"></line>
                        <line class="stroke" x1="6" x2="15" y1="9" y2="9"></line>
                        <line class="stroke" x1="6" x2="15" y1="14" y2="14"></line>
                        <line class="stroke" x1="3" x2="3" y1="4" y2="4"></line>
                        <line class="stroke" x1="3" x2="3" y1="9" y2="9"></line>
                        <line class="stroke" x1="3" x2="3" y1="14" y2="14"></line>
                    </svg>
                </span>
            </a>

            <div v-if="maxChars > 0" class="chars-indicator tag" :class="{'is-danger': numChars > maxChars}">{{ numChars }}/{{ maxChars }}</div>

            <a class="button toolbar-button" @click.prevent="toggleLinkUi(null)" :class="{'is-active': testPresenceinSelection('makeLink', 'makeLink')}" v-if="computedOptions.allowLinks">
                <span class="icon">
                    <svg viewBox="0 0 18 18">
                        <line class="stroke" x1="7" x2="11" y1="7" y2="11"></line>
                        <path class="even stroke" d="M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"></path>
                        <path class="even stroke" d="M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"></path>
                    </svg>
                </span>
            </a>

            <div class="link-ui" v-if="showLinkUi">
                <form @submit.prevent="toolbarClicked('makeLink')">
                    <input type="text" v-model="link" class="input" placeholder="URL..." />
                    <a class="button" @click.prevent="toolbarClicked('makeLink')">Link einfügen</a>
                </form>
            </div>

        </div>
        <div class="wysiwyg-editor" ></div>
        <span class="wysiwyg-placeholder" v-html="computedOptions.placeholder" v-if="numChars == 0"></span>
    </div>
</template>

<script>
    import Squire from 'squire-rte';

    import { DomUtils } from '../../../utils';

    export default {
        name: 'wysiwyg',

        props: {
            options: {
                type: Object,
                'default': () => { return {}; },
            },
            value: {
                type: String,
            },
        },

        data() {
            return {
                editor: null,
                showLinkUi: false,
                link: '',
                maxChars: 0,
                numChars: 0,
                defaultOptions: {
                    readonly: false,
                    placeholder: '',
                    blockTag: 'P',
                    isSetHTMLSanitized: true,
                    isInsertedHTMLSanitized: true,
                    maxChars: 0,
                    allowLinks: false,
                }
            };
        },

        computed: {
            computedOptions() {
                return Object.assign(this.defaultOptions, this.options);
            },
            sanitizedLink() {
                if(!this.link) {
                    return '';
                }

                if(this.link.match(/^\//)) {
                    return this.link;
                }

                if(this.link.match(/^https?:\/\//i) || this.link.match(/^mailto:\/\//i)) {
                    return this.link;
                }

                return `http://${this.link}`;
            },
        },

        mounted() {
            this.editor = new Squire(this.$el.getElementsByClassName('wysiwyg-editor')[0], this.computedOptions);
            if(this.computedOptions.readonly) {
                this.editor.getRoot().setAttribute('contenteditable', 'false');
            }
            this.maxChars = this.computedOptions.maxChars;

            this.editor.changeBlockType = function(tag, attrs) {
                if(!tag) {
                    let config = this._config;
                    tag = config.blockTag;
                    attrs = config.blockAttributes;
                }
                return this.modifyBlocks(function(frag) {
                    let walker = Squire.getBlockWalker(frag, this._root);
                    let output = this.getDocument().createDocumentFragment();
                    let node = walker.nextNode();
                    while(node) {
                        output.appendChild(this.createElement(tag, attrs, [
                            Squire.empty(node)
                        ]));
                        node = walker.nextNode();
                    }
                    return output;
                });
            };

            this.editor.makeHeadline = function(tag) {
                this.changeBlockType(tag);
                return this.focus();
            };
            this.editor.removeHeadline = function() {
                this.changeBlockType();
                return this.focus();
            };

            this.editor.addEventListener('input', () => {
                let html = this.editor.getHTML();
                if(html !== this.value) {
                    this.$emit('input', html);
                    this.calculateNumChars();
                }
            });

            setTimeout(() => {
                this.updateEditor();
            }, 0);
        },

        beforeDestroy() {
            if(this.editor) {
                this.editor.destroy();
            }
        },

        watch: {
            value() {
                this.updateEditor();
            },
        },

        methods: {
            updateEditor() {
                if(this.value !== this.editor.getHTML()) {
                    try {
                        this.editor.setHTML(this.value);
                    } catch (e) {}
                    this.calculateNumChars();
                }
            },

            testPresenceinSelection(name, action) {
                if(!this.editor) {
                    return false;
                }
                const formats = {
                    bold: 'B',
                    italic: 'I',
                    underline: 'U',
                    makeOrderedList: 'OL',
                    makeUnorderedList: 'UL',
                    makeLink: 'A',
                    makeHeadline2: 'H2',
                    makeHeadline3: 'H3',
                };
                const validations = {
                    bold: (/>B\b/),
                    italic: (/>I\b/),
                    underline: (/>U\b/),
                    makeOrderedList: (/>OL\b/),
                    makeUnorderedList: (/>UL\b/),
                    makeLink: (/>A\b/),
                    makeHeadline2: (/>H2\b/),
                    makeHeadline3: (/>H3\b/),
                };

                const format = formats[name];
                const validation = validations[name];

                let path = this.editor.getPath();
                let testTrue = (validation.test(path) | this.editor.hasFormat(format));
                if(name === action && testTrue) {
                    return true;
                } else {
                    return false;
                }
            },

            toolbarClicked(action) {
                const testBold = this.testPresenceinSelection('bold', action);
                const testItalic = this.testPresenceinSelection('italic', action);
                const testUnderline = this.testPresenceinSelection('underline', action);
                const testOrderedList = this.testPresenceinSelection('makeOrderedList', action);
                const testUnorderedList = this.testPresenceinSelection('makeUnorderedList', action);
                const testLink = this.testPresenceinSelection('makeLink', action);
                const testHeadline2 = this.testPresenceinSelection('makeHeadline2', action);
                const testHeadline3 = this.testPresenceinSelection('makeHeadline3', action);

                if(action === 'bold') {
                    if(testBold) {
                        this.editor.removeBold();
                    } else {
                        this.editor.bold();
                        this.editor.focus();
                    }
                } else if(action === 'italic') {
                    if(testItalic) {
                        this.editor.removeItalic();
                    } else {
                        this.editor.italic();
                        this.editor.focus();
                    }
                } else if(action === 'underline') {
                    if(testUnderline) {
                        this.editor.removeUnderline();
                    } else {
                        this.editor.underline();
                        this.editor.focus();
                    }
                } else if(action === 'makeOrderedList') {
                    if(testOrderedList) {
                        this.editor.removeList();
                    } else {
                        this.editor.makeOrderedList();
                        this.editor.focus();
                    }
                } else if(action === 'makeUnorderedList') {
                    if(testUnorderedList) {
                        this.editor.removeList();
                    } else {
                        this.editor.makeUnorderedList();
                        this.editor.focus();
                    }
                } else if(action === 'makeLink') {
                    if(testLink) {
                        this.editor.removeLink();
                    } else {
                        this.editor.makeLink(this.sanitizedLink);
                        this.editor.focus();
                        this.toggleLinkUi(false);
                    }
                } else if(action === 'makeHeadline2') {
                    if(testHeadline2) {
                        this.editor.removeHeadline();
                    } else {
                        this.editor.makeHeadline('h2');
                        this.editor.focus();
                    }
                } else if(action === 'makeHeadline3') {
                    if(testHeadline3) {
                        this.editor.removeHeadline();
                    } else {
                        this.editor.makeHeadline('h3');
                        this.editor.focus();
                    }
                }
            },

            toggleLinkUi(onOff = null) {
                this.link = '';
                if(onOff === null) {
                    this.showLinkUi = !this.showLinkUi;
                } else {
                    this.showLinkUi = onOff;
                }
                if(this.showLinkUi) {
                    this.selection = this.editor.getSelection();
                }
            },

            calculateNumChars() {
                if(!this.editor) {
                    this.numChars = 0;
                }

                let el = this.$el.getElementsByClassName('wysiwyg-editor')[0];
                if(el.childNodes.length === 1) {
                    if(el.childNodes[0].childNodes.length === 1) {
                        if(el.childNodes[0].childNodes[0].tagName === 'BR') {
                            this.numChars = 0;
                            return;
                        }
                    }
                }
                this.numChars = Math.max(0, DomUtils.toText(el).length - 2);
            },
        },
    };
</script>


<style lang="scss">
    @import './wysiwyg.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/wysiwyg/wysiwyg.vue